export enum BrokerStoreEvent {
  searchStart = 'search-start',
  searchSuccess = 'search-success',
  searchFailure = 'search-failure',
}
